import PanelNew from '@/containers/SubscriptionFormPageNew/Panel/PanelNew'
import meterElec from '@/shared/components/SDComponentsNewDesign/meter_elec.svg'
import meterGas from '@/shared/components/SDComponentsNewDesign/meter_gas.svg'
import { useTranslation } from 'react-i18next'
import ElectricityMeter from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/ElectricityMeter'
import GasMeter from '@/containers/SubscriptionFormPageNew/Components/GasMeter/GasMeter'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'

const MeterIds = () => {
  const { t } = useTranslation()
  const { shouldShowMeterInformation } = useAddress()

  if (!shouldShowMeterInformation) {
    return (
      <div style={{ width: '100%' }}>
        <PanelNew
          alt={t('subscriptionForm:pdl_module.title')}
          title={t('subscriptionForm:pdl_module.title')}
          logo={meterElec}
          id='meter-id-address-missing'
        >
          {t('subscriptionForm:pdl_module.warning_address_needed')}
        </PanelNew>
        <PanelNew
          alt={t('subscriptionForm:pce_module.title')}
          title={t('subscriptionForm:pce_module.title')}
          logo={meterGas}
          id='GasMeter'
        >
          {t('subscriptionForm:pce_module.warning_address_needed')}
        </PanelNew>
      </div>
    )
  }
  return (
    <div style={{ width: '100%' }}>
      <PanelNew
        alt={t('subscriptionForm:pdl_module.title')}
        title={t('subscriptionForm:pdl_module.title')}
        logo={meterElec}
        id='ElectricityMeter'
      >
        <ElectricityMeter />
      </PanelNew>

      <PanelNew
        alt={t('subscriptionForm:pce_module.title')}
        title={t('subscriptionForm:pce_module.title')}
        logo={meterGas}
        id='GasMeter'
      >
        <GasMeter />
      </PanelNew>
    </div>
  )
}

export default MeterIds
